(function () {
    'use strict';
    angular.module('doclr.blocklist', []);
})();